{
  "LOGIN": {
    "TITLE": "ورود به چت ووت",
    "EMAIL": {
      "LABEL": "ایمیل",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "لطفا ایمیل خود را به شکل صحیح وارد کنید"
    },
    "PASSWORD": {
      "LABEL": "رمز عبور",
      "PLACEHOLDER": "رمز عبور"
    },
    "API": {
      "SUCCESS_MESSAGE": "ورود موفق",
      "ERROR_MESSAGE": "متاسفانه ارتباط با سرور برقرار نشد، مجددا امتحان کنید",
      "UNAUTH": "این نام کاربری و رمز عبور صحیح نیست"
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "با گوگل وارد شوید",
      "BUSINESS_ACCOUNTS_ONLY": "لطفا از آدرس ایمیل شرکت خود برای ورود استفاده کنید",
      "NO_ACCOUNT_FOUND": "ما نتوانستیم حسابی برای آدرس ایمیل شما پیدا کنیم."
    },
    "FORGOT_PASSWORD": "رمز عبورتان را فراموش کردید؟",
    "CREATE_NEW_ACCOUNT": "حساب جدید بسازید",
    "SUBMIT": "ورود",
    "SAML": {
      "LABEL": "Login via SSO",
      "TITLE": "Initiate Single Sign-on (SSO)",
      "SUBTITLE": "Enter your work email to access your organization",
      "BACK_TO_LOGIN": "Login via Password",
      "WORK_EMAIL": {
        "LABEL": "Work Email",
        "PLACEHOLDER": "Enter your work email"
      },
      "SUBMIT": "Continue with SSO",
      "API": {
        "ERROR_MESSAGE": "SSO authentication failed. Please check your credentials and try again."
      }
    }
  }
}
